import React, { useEffect, useRef } from "react";
import "./MicLevelVisualizer.css";

const BAR_LEVELS = [0.72, 1, 0.86, 0.64];
const IDLE_BAR_SCALE = 0.38;

export default function MicLevelVisualizer({ volumeRef, muted = false, demo = false }) {
  const barRefs = useRef([]);

  useEffect(() => {
    let frameId;
    let displayedLevel = 0;

    const updateBars = (timestamp = 0) => {
      const demoLevel = 0.13
        + ((Math.sin(timestamp / 230) + 1) * 0.035)
        + ((Math.sin(timestamp / 410) + 1) * 0.02);
      const rawLevel = muted ? 0 : demo ? demoLevel : Number(volumeRef?.current || 0);
      const targetLevel = Math.min(1, Math.max(0, rawLevel * 4));
      displayedLevel += (targetLevel - displayedLevel) * 0.25;

      barRefs.current.forEach((bar, index) => {
        if (!bar) return;
        const maxScale = BAR_LEVELS[index];
        const scale = IDLE_BAR_SCALE + displayedLevel * (maxScale - IDLE_BAR_SCALE);
        bar.style.transform = `scaleY(${scale.toFixed(3)})`;
      });

      frameId = window.requestAnimationFrame(updateBars);
    };

    frameId = window.requestAnimationFrame(updateBars);
    return () => window.cancelAnimationFrame(frameId);
  }, [demo, muted, volumeRef]);

  return (
    <div className="mic-level-visualizer" aria-hidden="true">
      {BAR_LEVELS.map((maxScale, index) => (
        <span
          className="mic-level-visualizer__bar"
          key={maxScale}
          ref={(element) => {
            barRefs.current[index] = element;
          }}
        />
      ))}
    </div>
  );
}
